"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //      

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require("react-router-dom");

var _constants = require("../utils/constants");

var _semanticUiReact = require("semantic-ui-react");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
	logo: {
		marginRight: "1em",
		marginLeft: "1em"
	},
	logoICGC: {
		width: "85px"
	},
	logo65: {
		width: "65px",
		marginLeft: "10px",
		marginRight: "10px"
	},
	myMenu: {
		height: "3.8em",
		borderBottom: "2px solid #e4191d"
	},
	selectedStyle: {
		backgroundColor: "white",
		/* borderBottom: "2px solid #e4191d", */
		color: "#e4191d",
		fontWeight: "bold"
	},
	menuItem: {
		color: "#767676",
		fontSize: "1.1rem"
	},
	version: {
		right: "60px",
		position: "fixed",
		fontSize: "0.7em"

	}

};

function orgaLogo(props) {

	if (props.organization) {

		if (props.organization == _constants.ORGA_TV3) {

			return _react2.default.createElement(_semanticUiReact.Image, {
				size: "mini",
				title: props.organization || "",
				src: "./TV3.svg",
				href: "https://www.ccma.cat/el-temps/",
				style: styles.logo
			});
		} else if (props.organization == _constants.ORGA_SMC) {

			return _react2.default.createElement(_semanticUiReact.Image, {
				size: "mini",
				title: "Servei Meteorològic de Catalunya",
				src: "./smc.png",
				href: "https://www.meteo.cat/",
				style: styles.logo65
			});
		} else {

			return _react2.default.createElement(_semanticUiReact.Image, {
				size: "mini",
				title: props.organization || "",
				src: "./blank.png",
				style: styles.logo
			});
		}
	} else {

		return _react2.default.createElement(_semanticUiReact.Image, {
			size: "mini",
			title: props.organization || "",
			src: "./blank.png",
			style: styles.logo
		});
	}
}

//console.info("sss",orgaLogo());

var FixedMenuLayout = function FixedMenuLayout(props) {
	return _react2.default.createElement(
		_semanticUiReact.Menu,
		{ borderless: true, fixed: "top", style: _extends({}, styles.myMenu, props.styles) },
		_react2.default.createElement(
			_semanticUiReact.Menu.Item,
			{ header: true },
			_react2.default.createElement(_semanticUiReact.Image, {
				size: "mini",
				src: "./ICGC_color_normatiu.svg",
				title: "Institut Cartogr\xE0fic i Geol\xF2gic de Catalunya",
				href: "http://www.icgc.cat/",
				style: styles.logoICGC
			}),
			orgaLogo(props),
			props.title || "Eina de configuració de VISORS"
		),
		!props.isVisor && _react2.default.createElement(
			_semanticUiReact.Menu.Item,
			null,
			_react2.default.createElement(
				_reactRouterDom.NavLink,
				{ style: styles.menuItem, to: {
						pathname: "/editor",
						state: { header: props.header }
					}, activeStyle: styles.selectedStyle },
				_react2.default.createElement(_semanticUiReact.Icon, { name: "edit" }),
				"Editor (nou visor)"
			)
		),
		!props.isVisor && _react2.default.createElement(
			_semanticUiReact.Menu.Item,
			null,
			_react2.default.createElement(
				_reactRouterDom.NavLink,
				{ style: styles.menuItem, to: {
						pathname: "/gestor",
						state: { header: props.header }
					}, activeStyle: styles.selectedStyle },
				_react2.default.createElement(_semanticUiReact.Icon, { name: "list" }),
				"Gestor"
			)
		),
		props.renderButtons
	);
};

exports.default = FixedMenuLayout;


FixedMenuLayout.propTypes = {
	renderButtons: _propTypes2.default.object,
	header: _propTypes2.default.object,
	title: _propTypes2.default.string,
	organization: _propTypes2.default.string,
	styles: _propTypes2.default.object,
	isVisor: _propTypes2.default.bool
};
